import Jsona from "jsona";

import { setUser, captureException, addBreadcrumb } from "@sentry/browser";
import orderMixin from "@/mixins/orderMixin";
import HTTP from "../http";

const dataFormatter = new Jsona();

const SHALLOW_LIST_RELATION = [
  "customer.account",
  "professional.account.profile",
  "schedule_event",
  "address",
  "payments.funding_instrument"
];

const DASHBOARD_PAGE_SIZE = 25;

export default {
  async index(page, sort) {
    try {
      let results = await HTTP.normal.get(
        `/orders?include=cycle,schedule_event,professional.account.profile,customer.account.profile,address.district.city.state&page[number]=${page}&sort=-created_at`
      );

      return {
        data: dataFormatter.deserialize(results.data),
        meta: results.data.meta
      };
    } catch (e) {
      throw "Ocorreu um erro ao listar os pedidos!";
    }
  },

  async show(id) {
    try {
      let results = await HTTP.normal.get(
        `/orders/${id}/?include=schedule_event,professional.account.profile,professional.account.schedule,professional.account.phones,professional.professional_rating,customer.account.profile,address.district.pricing,address.district.city.state.country,payments.funding_instrument,amount.subtotal,coupon`
      );

      return dataFormatter.deserialize(results.data);
    } catch (e) {
      throw "Ocorreu um erro ao buscar o pedido!";
    }
  },

  async create(payload) {
    try {
      let order = await HTTP.normal.post("/orders", payload);
      return dataFormatter.deserialize(order.data);
    } catch (e) {
      setUser({ id: payload.data.relationships.customer.data.id });
      addBreadcrumb({
        data: {
          payload: JSON.stringify(payload),
          respose: JSON.stringify(e.response.data)
        }
      });
      captureException(e);
      throw "Ocorreu um erro ao criar o pedido!";
    }
  },

  async createOnGateway(order_id) {
    try {
      await HTTP.normal.post(`orders/${order_id}/create-on-gateway`);
    } catch (e) {
      throw e;
    }
  },

  async checkIfCouponApplies(payload) {
    try {
      let res = await HTTP.normal.get(
        `/orders/${payload.order}/check-if-coupon-applies?coupon_id=${
          payload.coupon
        }`
      );

      if (!res.data.data.passes_restrictions)
        throw "O cupom informado não pode ser aplicado à este pedido!";
    } catch (e) {
      throw e;
    }
  },

  async applyCoupon(payload) {
    try {
      let data = {
        data: {
          type: "orders",
          id: payload.order,
          relationships: {
            coupon: {
              data: {
                type: "coupons",
                id: payload.coupon
              }
            }
          }
        }
      };

      let order = await HTTP.normal.patch(
        `/orders/${payload.order}?include=coupon`,
        data
      );
      return dataFormatter.deserialize(order.data);
    } catch (e) {
      throw "Ocorreu um erro ao aplicar o cupom!";
    }
  },

  async removeCoupon(orderId) {
    try {
      let data = {
        data: {
          type: "orders",
          id: orderId,
          relationships: {
            coupon: {
              data: null
            }
          }
        }
      };

      let order = await HTTP.normal.patch(`/orders/${orderId}`, data);
      return dataFormatter.deserialize(order.data);
    } catch (e) {
      throw "Ocorreu um erro ao remover o cupom!";
    }
  },

  async ordersPendingPayment() {
    const pendingPaymentStatuses = orderMixin.methods.statesToCheckout();

    const pendingOrders = await HTTP.normal.get(
      `/orders?include=${SHALLOW_LIST_RELATION.join(
        ","
      )}&filter[status]=${pendingPaymentStatuses.join(
        ","
      )}&filter[belongs_to_cycle]='false'&page[size]=${DASHBOARD_PAGE_SIZE}&sort=-created_at`
    );

    return dataFormatter.deserialize(pendingOrders.data);
  },

  async ordersConfirmed() {
    const confirmedOrders = await HTTP.normal.get(
      `/orders?include=${SHALLOW_LIST_RELATION.join(
        ","
      )}&filter[status]=paid&page[size]=${DASHBOARD_PAGE_SIZE}&sort=schedule_event.starts_at`
    );

    return dataFormatter.deserialize(confirmedOrders.data);
  },

  async ordersNotProvided() {
    const ordersNotProvided = await HTTP.normal.get(
      `/orders?include=${SHALLOW_LIST_RELATION.join(
        ","
      )}&filter[status]=service_not_provided&page[size]=${DASHBOARD_PAGE_SIZE}`
    );

    return dataFormatter.deserialize(ordersNotProvided.data);
  },

  async ordersProvisioned() {
    const ordersProvisioned = await HTTP.normal.get(
      `/orders?include=${SHALLOW_LIST_RELATION.join(
        ","
      )}&filter[status]=provisioning&page[size]=${DASHBOARD_PAGE_SIZE}`
    );

    return dataFormatter.deserialize(ordersProvisioned.data);
  },

  async orderProductsPricing() {
    const response = await HTTP.normal.get("/orders/products-pricing");

    return response.data;
  }
};



// WEBPACK FOOTER //
// ./src/api/modules/orders.js